'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { Heading } from '../Heading/Heading.js';

const DropdownHeading = forwardRef(function DropdownHeading({ className, ...rest }, ref) {
    return jsx(Heading, { ref: ref, ...rest });
});

export { DropdownHeading };
